import { render, staticRenderFns } from "./payment-success.vue?vue&type=template&id=a810fb9a&scoped=true&"
import script from "./payment-success.vue?vue&type=script&lang=js&"
export * from "./payment-success.vue?vue&type=script&lang=js&"
import style0 from "./payment-success.vue?vue&type=style&index=0&id=a810fb9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a810fb9a",
  null
  
)

export default component.exports